import { useState } from "react"
import { Card, CommandButton, HeaderMenu } from "../../../../../components"
import { FormProvider, useForm } from "react-hook-form"
import type { AddressList, PersonalList, ProfileList } from "../types"
import { RenderProvider } from "../utils"
import { Tab } from "./ChildItem/components/Item/components/Tabs"
import { FormPersonalData } from "./FormSection/FormPersonalData"
import { FormProfile } from "./FormSection/FormProfile"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import toast from "react-hot-toast"
import { useApi, usePermission } from "../../../../../utils"
import { FormAddress } from "./FormSection/FormAddress"
import { FormMap } from "./FormSection/FormMap"

export function CreatePage(props: { asModal?: boolean }) {
  const api = useApi()
  const tabs = ["PROFILE", "ADDRESS", "MAP"];
  const permission = usePermission(["CT04"])

  const [personalDataPayload, setPersonalDataPayload] = useState<any>(undefined);
  const [activeTab, setActiveTab] = useState<number | undefined>(undefined);
  const [fileValue, setFileValue] = useState<File | undefined>(undefined);
  const [isActiveSubmit, setIsActiveSubmit] = useState<any>({ 
    personal: false, 
    profile: false,
    address: false,
    map: false
  })
  const [disableTab, setDisableTab] = useState(false);
  const [responseValue, setResponseValue] = useState<any>(undefined);

  type CreatePersonalData = Pick<PersonalList, "vendor_code" | "vendor_name" | "vendor_Foto">;

  // Form Values
  const defaultValues:CreatePersonalData = {
    vendor_code: "",
    vendor_name: "",
    vendor_Foto: ""
  }
  const profileValues = {
    handphone: "",
    email: "",
    website: "",
    card_label:  undefined,
    group_card: "3",
    category_vendor_id: undefined,
    source_from: "",
    employee_id: undefined,
    media: "",
    price_level_id: "8",
    payment_term_id: undefined,
    max_balance: undefined,
    bank_id: undefined,
    bank_account: "",
    bank_beneficiary: "",
    bank_branch: "",
  }
  const addressValues = {
    address_type_id: "1",
    address_type_id_2: "2",
    country_id: undefined,
    country_id_2: undefined,
    province_id: undefined,
    province_id_2: undefined,
    regency_id: undefined,
    regency_id_2: undefined,
    subdistrict_id: undefined,
    subdistrict_id_2: undefined,
    village_id: undefined,
    village_id_2: undefined,
    address: undefined,
    address_2: undefined,
  }
  const mapValues = { link_map: "" }
  const validationSchema = yup.object().shape({ vendor_name: yup.string().label("Vendor name").required() })

  // Handle Form
  const methods = useForm<CreatePersonalData>({
    defaultValues,
    resolver: yupResolver(validationSchema)
  })
  const profileMethods = useForm<ProfileList>({ defaultValues: profileValues })
  const addressMethods = useForm<AddressList>({ defaultValues: addressValues })
  const mapMethods = useForm<ProfileList>({ defaultValues: mapValues })

  // Handle Submit
  const onSubmit = (value: PersonalList) => {
    const formData = new FormData();
    
    formData.append('vendor_code', value?.vendor_code!);
    formData.append('vendor_name', value?.vendor_name);
    if(value?.vendor_Foto){formData.append(fileValue ? 'vendor_Foto' : "", value?.vendor_Foto)}

    return new Promise<void>((resolve) => {
      toast.promise(
        api.post("/vendor/add", formData),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => {
            if (err.response && err.response.status === 422) {
              return err.response.data.message || "Bad Request";
            } else {
              return "An error occurred";
            }
          }
        }
      )
      .then((res) => {
        setActiveTab(0)
        setDisableTab(true)
        setPersonalDataPayload(res?.data?.payload)
        console.log(res?.data?.payload)
        console.log(res?.data)
        console.log(res)
        setIsActiveSubmit({ ...isActiveSubmit, personal: true })
      })
      .catch(() => {})
      .finally(resolve)
    })
  }
  const onProfileSubmit = (value: ProfileList) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.put(`/vendor/updateprofile?vendor_id=${personalDataPayload?.vendor_id}`, value),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => {
            if (err.response && err.response.status === 422) {
              return err.response.data.message || "Bad Request";
            } else {
              return "An error occurred";
            }
          }
        }
      )
      .then((res) => {
        setIsActiveSubmit({ ...isActiveSubmit, profile: true })
        setResponseValue(res?.data?.payload?.[0])
      })
      .catch(() => {})
      .finally(resolve)
    })
  }
  const onAddressSubmit = (value: AddressList) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.put(`/vendor/updateaddress?vendor_id=${personalDataPayload?.vendor_id}`, value),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message
        }
      )
      .then((res) => {
        setIsActiveSubmit({ ...isActiveSubmit, profile: true })
        setResponseValue(res?.data?.payload?.[0])
      })
      .catch(() => {})
      .finally(resolve)
    })
  }
  const onMapSubmit = (value: ProfileList) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.put(`/vendor/updatealinkmap?vendor_id=${personalDataPayload?.vendor_id}`, value),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => {
            if (err.response && err.response.status === 422) {
              return err.response.data.message || "Bad Request";
            } else {
              return "An error occurred";
            }
          }
        }
      )
      .then((res) => {
        setIsActiveSubmit({ ...isActiveSubmit, profile: true })
        setResponseValue(res?.data?.payload?.[0])
      })
      .catch(() => {})
      .finally(resolve)
    })
  }

  return (
    <RenderProvider>
      <section className="container my-2">
        {!props.asModal && (
          <HeaderMenu title="DATA ENTRY | CREATE NEW VENDOR" />
        )}
        <Card>
          <Card.Body>
            <div className="lg:flex">
              <div className="lg:w-[34%] mr-0.5">
                <button className="bg-[#3c3c3c] px-4 py-2 w-full mr-0.5 text-white text-[12px]"><b>PERSONAL DATA</b></button>
                <div className={`max-w-sm w-full lg:max-w-full lg:flex h-[${methods?.control?._formState?.errors ? "1950" : "1750px"}]`}>
                  <div className="w-full border border-[#3c3c3c] lg:border-[#3c3c3c] p-6">
                    <FormProvider {...methods}>
                      {/* @ts-ignore */}
                      <FormPersonalData action="CREATE" onSubmit={onSubmit} setFileValue={setFileValue} isActiveSubmit={isActiveSubmit?.personal} permission={permission?.canCreate} />
                    </FormProvider>
                  </div>
                </div>
              </div>
              <div className="lg:w-[66%]">
                <Tab tabs={tabs} activeTab={activeTab} disabled={!disableTab} setActiveTab={setActiveTab} dataProfile={responseValue} className="text-[11px]" />
                <div className="">
                  <div className={`max-w-sm w-full lg:max-w-full lg:flex h-[${methods?.control?._formState?.errors ? "1950" : "1750px"}]`}>
                    <div className="w-full border border-[#3c3c3c] lg:border-[#3c3c3c] p-6 mr-0.5">
                      <FormProvider {...profileMethods}>
                        {activeTab === 0 && <FormProfile permission={"CT041"} onSubmit={onProfileSubmit} />}
                      </FormProvider>
                      <FormProvider {...addressMethods}>
                        {activeTab === 1 && <FormAddress permission={"CT041"} onSubmit={onAddressSubmit} />}
                      </FormProvider>
                      <FormProvider {...mapMethods}>
                        {activeTab === 2 && <FormMap permission={"CT041"} onSubmit={onMapSubmit} />}
                      </FormProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      <section className="mt-2">
          <Card>
            <Card.Body className="flex flex-col gap-5">
              <section className="flex flex-wrap justify-between items-center gap-3">
                <section className="flex flex-wrap gap-3">
                  <CommandButton actiontype="help" />
                  <CommandButton actiontype="print" />
                  <CommandButton actiontype="email" />
                  <CommandButton actiontype="export" />
                </section>
              </section>
            </Card.Body>
          </Card>
        </section>
      </section>
    </RenderProvider>
  )
}